"use client";

import { BrokerAvatar } from "@/components/brokers/broker-avatar";
import { api } from "@/lib/api-client";
import type { DetailedListingListItem } from "@/lib/types";

export type ListingPreviewAgentProps = {
  listing: DetailedListingListItem;
};

export function ListingPreviewAgent({ listing }: ListingPreviewAgentProps) {
  const { data } = api.listings.getMinimalListingAgent.useQuery(
    {
      id: listing.id,
    },
    {
      retry: false,
      refetchOnWindowFocus: false,
    },
  );

  if (!data?.agent) {
    return null;
  }

  return (
    <BrokerAvatar
      id={data.agent.id}
      name={data.agent.name}
      image={data.agent.image}
      isVerified={data.agent.isVerified ?? false}
      showVerified={false}
      size="xs"
      className="!size-6 border border-white"
    />
  );
}
